import GridToolbarProps from './Toolbar'

let KendoGridToolbar = {
    name: 'kendo-grid-toolbar-item',
    render () {
        return null
    },
    mixins: [GridToolbarProps]
}

export default KendoGridToolbar


// WEBPACK FOOTER //
// ./packages/kendo-grid-vue-wrapper/src/KendoGridToolbar/index.js